import React, { useEffect } from 'react';

type WindowDimensions = {
  width: number;
  height: number;
};

function getWindowDimensions(): WindowDimensions {
  const { innerWidth, innerHeight } = window;
  return {
    width: innerWidth,
    height: innerHeight,
  };
}

/**
 * A helper hook used to keep track of the screen's dimensions, which we will use to
 * adjust the camera's viewport in the PhotoCapturer component.
 */
export default function useWindowDimensions(): WindowDimensions {
  const [dimensions, updateDimensions] = React.useState(getWindowDimensions());
  useEffect(() => {
    function handleResize(): void {
      updateDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
}
